"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiateCallToLeadError = exports.LeadPriority = exports.MloLeadDisposition = exports.ThirdPartyLeadOwnerService = exports.ThirdPartyApplicantType = exports.OutboundDialerCallTopic = exports.isLeadSourceInboundServicing = exports.LEAD_SOURCES_WITH_NO_MLO_AT_INQUIRY_CREATION = exports.isMloCrmAffiliateLeadSource = exports.MLO_CRM_AFFILIATE_LEAD_SOURCES = exports.ThirdPartyLeadSource = exports.ThirdPartyLeadEmploymentStatus = exports.ThirdPartyLeadCreditProfile = exports.ThirdPartyLeadPropertyUse = exports.ThirdPartyLeadPropertyType = exports.ThirdPartyLeadLoanUsage = exports.ThirdPartyLeadLoanType = void 0;
var ThirdPartyLeadLoanType;
(function (ThirdPartyLeadLoanType) {
    ThirdPartyLeadLoanType["HomeEquity"] = "heq";
    ThirdPartyLeadLoanType["HomeRefinance"] = "Home Refinance";
})(ThirdPartyLeadLoanType || (exports.ThirdPartyLeadLoanType = ThirdPartyLeadLoanType = {}));
var ThirdPartyLeadLoanUsage;
(function (ThirdPartyLeadLoanUsage) {
    ThirdPartyLeadLoanUsage["HomeImprovement"] = "homeimprovement";
    ThirdPartyLeadLoanUsage["DebtConsolidation"] = "debtconsolidation";
    ThirdPartyLeadLoanUsage["MajorPurchase"] = "Majorpurchase";
    ThirdPartyLeadLoanUsage["Other"] = "other";
})(ThirdPartyLeadLoanUsage || (exports.ThirdPartyLeadLoanUsage = ThirdPartyLeadLoanUsage = {}));
var ThirdPartyLeadPropertyType;
(function (ThirdPartyLeadPropertyType) {
    ThirdPartyLeadPropertyType["SingleFamilyHome"] = "Single Family Home";
    ThirdPartyLeadPropertyType["MultiFamilyHome"] = "Multi-Family Home";
    ThirdPartyLeadPropertyType["Condominium"] = "Condominium";
    ThirdPartyLeadPropertyType["Townhome"] = "Townhome";
})(ThirdPartyLeadPropertyType || (exports.ThirdPartyLeadPropertyType = ThirdPartyLeadPropertyType = {}));
var ThirdPartyLeadPropertyUse;
(function (ThirdPartyLeadPropertyUse) {
    ThirdPartyLeadPropertyUse["PrimaryHome"] = "Primary Home";
    ThirdPartyLeadPropertyUse["SecondaryHome"] = "Secondary Home";
    ThirdPartyLeadPropertyUse["RentalProperty"] = "Rental Property";
})(ThirdPartyLeadPropertyUse || (exports.ThirdPartyLeadPropertyUse = ThirdPartyLeadPropertyUse = {}));
var ThirdPartyLeadCreditProfile;
(function (ThirdPartyLeadCreditProfile) {
    ThirdPartyLeadCreditProfile["Excellent"] = "Excellent > 740";
    ThirdPartyLeadCreditProfile["Good"] = "Good 700-739";
    ThirdPartyLeadCreditProfile["Fair"] = "Fair 660-699";
    ThirdPartyLeadCreditProfile["Poor"] = "Poor < 659";
})(ThirdPartyLeadCreditProfile || (exports.ThirdPartyLeadCreditProfile = ThirdPartyLeadCreditProfile = {}));
var ThirdPartyLeadEmploymentStatus;
(function (ThirdPartyLeadEmploymentStatus) {
    ThirdPartyLeadEmploymentStatus["Employed"] = "Employed";
    ThirdPartyLeadEmploymentStatus["NotEmployed"] = "Not Employed";
    ThirdPartyLeadEmploymentStatus["SelfEmployed"] = "Self Employed";
    ThirdPartyLeadEmploymentStatus["Retired"] = "Retired";
    ThirdPartyLeadEmploymentStatus["Military"] = "Military";
    ThirdPartyLeadEmploymentStatus["Other"] = "Other";
})(ThirdPartyLeadEmploymentStatus || (exports.ThirdPartyLeadEmploymentStatus = ThirdPartyLeadEmploymentStatus = {}));
/**
 * @TranslateToPython
 * This enum represents the different sources of third party leads. Note that it is NOT an exhaustive list of all possible lead sources. To find all possible lead sources, use the partnerDetailsHelper.getAllActive() method.
 */
var ThirdPartyLeadSource;
(function (ThirdPartyLeadSource) {
    ThirdPartyLeadSource["Bankrate"] = "Bankrate";
    ThirdPartyLeadSource["BestMoney"] = "BestMoney";
    ThirdPartyLeadSource["Hearth"] = "Hearth";
    ThirdPartyLeadSource["AvenAdvisor"] = "AvenAdvisor";
    ThirdPartyLeadSource["AvenCashoutRefi"] = "AvenCashoutRefi";
    ThirdPartyLeadSource["AvenMloCrmManualCsvDump"] = "AvenMloCrmManualCsvDump";
    ThirdPartyLeadSource["AvenInternalDropoffs"] = "AvenInternalDropoffs";
    ThirdPartyLeadSource["AvenInternalUpgrade"] = "AvenInternalUpgrade";
    ThirdPartyLeadSource["Lakeview"] = "Lakeview";
    /**
     * @deprecated Use LendingTreeRefi or LendingTreeHomeEquity instead
     */
    ThirdPartyLeadSource["LendingTree"] = "LendingTree";
    ThirdPartyLeadSource["LendingTreeRefi"] = "LendingTreeRefi";
    ThirdPartyLeadSource["LendingTreeHomeEquity"] = "LendingTreeHomeEquity";
    ThirdPartyLeadSource["Aether"] = "Aether";
    ThirdPartyLeadSource["Acorn"] = "Acorn";
    ThirdPartyLeadSource["SubHub"] = "SubHub";
    ThirdPartyLeadSource["FreeRateUpdate"] = "FreeRateUpdate";
    ThirdPartyLeadSource["NerdWallet"] = "NerdWallet";
    ThirdPartyLeadSource["AvenAcceptedNotScheduledDropoffs"] = "AvenAcceptedNotScheduledDropoffs";
    // Funnel dropoff stages for internal re-engagement leads
    ThirdPartyLeadSource["AvenPqNoPqaDropoffs"] = "AvenPqNoPqaDropoffs";
    ThirdPartyLeadSource["AvenPqaNoIncomeVerifiedDropoffs"] = "AvenPqaNoIncomeVerifiedDropoffs";
    ThirdPartyLeadSource["AvenOfferOrIncomeVerifiedNoAcceptDropoffs"] = "AvenOfferOrIncomeVerifiedNoAcceptDropoffs";
    ThirdPartyLeadSource["AvenAcceptNoScheduleDropoffs"] = "AvenAcceptNoScheduleDropoffs";
    ThirdPartyLeadSource["AvenScheduledNoShowDropoffs"] = "AvenScheduledNoShowDropoffs";
    ThirdPartyLeadSource["DmStaleApplications"] = "DmStaleApplications";
    ThirdPartyLeadSource["AvenConcierge"] = "AvenConcierge";
    // Stuck-state applications (preQualified / offered / awaitingNotarizations) resurrected by an MLO from the
    // concierge resurrection pool. Kept separate from AvenConcierge so resurrection outreach stays attributable.
    ThirdPartyLeadSource["MloResurrection"] = "MloResurrection";
    /**
     * @deprecated An affiliate Calendly booking attributes back to the affiliate source the lead already
     * has (see MLO_CRM_AFFILIATE_LEAD_SOURCES), so nothing creates new leads under this source. The value stays
     * because existing third_party_lead rows and the Affiliate partner_details row still carry the string.
     */
    ThirdPartyLeadSource["Affiliate"] = "Affiliate";
    // PQ leads routed to an MLO + SMS drip. Value kept as the legacy 'AvenConciergeHighLineSize' string
    // to avoid migrating existing prod rows; the cohort was broadened beyond high-line-size (see flow).
    ThirdPartyLeadSource["AvenConciergeRefiHighLineHighFico"] = "AvenConciergeHighLineSize";
    ThirdPartyLeadSource["AvenOutboundDialer"] = "AvenOutboundDialer";
    ThirdPartyLeadSource["RealTimeDialer"] = "RealTimeDialer";
    ThirdPartyLeadSource["AvenHomeMortgage"] = "AvenHomeMortgage";
    // Booked cardholders on the unsecured UCC card products (Rewards / Flex). Surfaced to the MLO
    // outbound dialer via rewardsFlexLeadsFlow; ranked by the rewardsFlex strategy. One source covers
    // both products — metadataJson.product (REWARDS | FLEX) lets analytics split lift after the fact.
    ThirdPartyLeadSource["AvenRewardsFlex"] = "AvenRewardsFlex";
    ThirdPartyLeadSource["HilWelcomeCall"] = "HilWelcomeCall";
    // Direct-mail recipients loaded into the MLO CRM so an MLO can text each one by hand. Nothing about
    // this cohort is automated: no drip, no dialer, no "new lead" MLO notification.
    ThirdPartyLeadSource["AvenDirectMailMms"] = "AvenDirectMailMms";
    ThirdPartyLeadSource["CreditKarma"] = "CreditKarma";
    ThirdPartyLeadSource["QuinnStreet"] = "QuinnStreet";
    ThirdPartyLeadSource["Moneylion"] = "Moneylion";
    ThirdPartyLeadSource["test"] = "test";
    ThirdPartyLeadSource["testUnit"] = "testUnit";
})(ThirdPartyLeadSource || (exports.ThirdPartyLeadSource = ThirdPartyLeadSource = {}));
/**
 * The purchased-affiliate lead sources. A lead's source is set when it arrives from the partner and is
 * never replaced: an affiliate Calendly booking attributes back to the source the lead already has.
 * Shared by the backend attribution path and the MLO CRM "All affiliates" lead-source filter.
 */
exports.MLO_CRM_AFFILIATE_LEAD_SOURCES = [
    ThirdPartyLeadSource.Bankrate,
    ThirdPartyLeadSource.NerdWallet,
    ThirdPartyLeadSource.QuinnStreet,
    ThirdPartyLeadSource.LendingTreeHomeEquity,
    ThirdPartyLeadSource.LendingTreeRefi,
];
const isMloCrmAffiliateLeadSource = (leadSource) => exports.MLO_CRM_AFFILIATE_LEAD_SOURCES.some((affiliateLeadSource) => affiliateLeadSource === leadSource);
exports.isMloCrmAffiliateLeadSource = isMloCrmAffiliateLeadSource;
exports.LEAD_SOURCES_WITH_NO_MLO_AT_INQUIRY_CREATION = Object.freeze([ThirdPartyLeadSource.CreditKarma]);
const LEAD_SOURCES_FOR_NON_MLO_AGENTS = new Set([ThirdPartyLeadSource.HilWelcomeCall]);
const isLeadSourceInboundServicing = (leadSource) => {
    return LEAD_SOURCES_FOR_NON_MLO_AGENTS.has(leadSource);
};
exports.isLeadSourceInboundServicing = isLeadSourceInboundServicing;
/**
 * Call topics for determining which pre-call SMS template to use.
 * Maps from lead source to determine the messaging context.
 */
var OutboundDialerCallTopic;
(function (OutboundDialerCallTopic) {
    OutboundDialerCallTopic["Concierge"] = "Concierge";
    OutboundDialerCallTopic["Mortgage"] = "Mortgage";
    OutboundDialerCallTopic["RewardsFlex"] = "RewardsFlex";
    OutboundDialerCallTopic["Default"] = "Default";
})(OutboundDialerCallTopic || (exports.OutboundDialerCallTopic = OutboundDialerCallTopic = {}));
var ThirdPartyApplicantType;
(function (ThirdPartyApplicantType) {
    ThirdPartyApplicantType["primary"] = "primary";
    ThirdPartyApplicantType["coApplicant"] = "coApplicant";
})(ThirdPartyApplicantType || (exports.ThirdPartyApplicantType = ThirdPartyApplicantType = {}));
var ThirdPartyLeadOwnerService;
(function (ThirdPartyLeadOwnerService) {
    ThirdPartyLeadOwnerService["mlo"] = "mlo";
    ThirdPartyLeadOwnerService["partnerApi"] = "partnerApi";
    ThirdPartyLeadOwnerService["advisor"] = "advisor";
})(ThirdPartyLeadOwnerService || (exports.ThirdPartyLeadOwnerService = ThirdPartyLeadOwnerService = {}));
/**
 * Disposition status set by MLO for a lead.
 * Used to track the outcome of MLO's interaction with the lead.
 */
var MloLeadDisposition;
(function (MloLeadDisposition) {
    MloLeadDisposition["doNotCallOrText"] = "Do not call or text";
    MloLeadDisposition["notInterested"] = "Not interested";
    MloLeadDisposition["followUp"] = "Follow up";
    MloLeadDisposition["noAnswer"] = "No answer";
    MloLeadDisposition["booked"] = "Booked";
    MloLeadDisposition["leftMessage"] = "Left message";
    MloLeadDisposition["wrongNumberOrBadLead"] = "Wrong number or bad lead";
    MloLeadDisposition["positiveCallNoFollowUp"] = "Positive Call - No Follow up";
    MloLeadDisposition["negativeCallNoFollowUp"] = "Negative Call - No Follow up";
    MloLeadDisposition["noAnswerDoNotRetry"] = "No answer - do not retry";
    MloLeadDisposition["waitingOnCustomer"] = "Waiting on customer";
})(MloLeadDisposition || (exports.MloLeadDisposition = MloLeadDisposition = {}));
/**
 * How urgently a lead should be worked: 1–10, higher is more urgent, null is no priority. The range is a
 * database constraint, and the gaps between the named levels are free for a source to rank between them.
 */
var LeadPriority;
(function (LeadPriority) {
    LeadPriority[LeadPriority["lowest"] = 1] = "lowest";
    LeadPriority[LeadPriority["low"] = 3] = "low";
    LeadPriority[LeadPriority["medium"] = 5] = "medium";
    LeadPriority[LeadPriority["high"] = 8] = "high";
    LeadPriority[LeadPriority["highest"] = 10] = "highest";
})(LeadPriority || (exports.LeadPriority = LeadPriority = {}));
/**
 * Error types that can occur when initiating a call to a lead
 */
var InitiateCallToLeadError;
(function (InitiateCallToLeadError) {
    InitiateCallToLeadError["noEligibleMlos"] = "noEligibleMlos";
    InitiateCallToLeadError["notLegalTime"] = "notLegalTime";
    InitiateCallToLeadError["noAvailableMlos"] = "noAvailableMlos";
    InitiateCallToLeadError["callCreationFailed"] = "callCreationFailed";
    InitiateCallToLeadError["communicationBlocked"] = "communicationBlocked";
})(InitiateCallToLeadError || (exports.InitiateCallToLeadError = InitiateCallToLeadError = {}));
